import { ISupplierForecast } from '@/coreDomainsModule/entities/businessForSupplierForecast';
import { SupplierForecast } from '@/coreInfrastructureModule/axios/generated/supplierForecastManage';

/**
 * APIからのresponseに含まれる仕入先内示をUI用に変換する
 */
export class SupplierForecastAdapter {
  /**
   * 仕入先内示のresponseをUI用に変換
   * @param response - APIのresponse
   */
  public static adapt = (response: SupplierForecast): ISupplierForecast => {
    return {
      supplierForecastId: response.supplierForecastId,
      equalCustomerForecastDataFlag: response.equalCustomerForecastDataFlag,
      createdYear: response.supplierForecastCreatedYear,
      createdMonth: response.supplierForecastCreatedMonth,
      targetYear: response.supplierForecastTargetYear,
      targetMonth: response.supplierForecastTargetMonth,
      amount: response.supplierForecastAmount,
      supplierForecastUpdateAt: response.updateAt,
    };
  };
}
